export default __webpack_public_path__ + "static/media/discover.2071a232.svg";